import { Dialog } from 'alurkerja-ui';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { MdCloudDownload } from 'react-icons/md';
import { downloadFile } from '@/utils/libs/fileUtil';
import { TestPlanService } from '@/api/testPlan';

type ExportTestPlanProps = {
  id?: string;
  projectName?: string;
};

export const ExportTestPlan: React.FC<ExportTestPlanProps> = ({
  id,
  projectName,
}) => {
  const { mutate: exportMutate, isPending: isExportLoading } =
    TestPlanService.useExport();
  const exportAction = (id: string) => {
    exportMutate(id, {
      onSuccess: response => {
        Dialog.success({
          title: 'Success',
          description: 'Test plan has been exported',
        });

        downloadFile(response, `TestPlan_${projectName}.xlsx`);
      },
      onError: () => {
        Dialog.error({
          title: 'Error',
          description: 'Failed to export test plan',
        });
      },
    });
  };

  return (
    <OutlineButton
      icon={<MdCloudDownload />}
      onClick={() => exportAction(id!)}
      isLoading={isExportLoading}
    >
      Export
    </OutlineButton>
  );
};
